import { DataPointWithValue } from '@src/types/DataPoint';
import { SiteMeta } from '@src/types/SiteMeta';

export type UnitConfig = {
  unitLabel: string;
  kw: string | undefined;
  kvar: string | undefined;
  soc: string | undefined;
  racksonline: string | undefined;
  invstatus: string | undefined;
  runmode: string | undefined;
};

export type DefaultSLDProps = {
  siteMeta: SiteMeta;
};

export type BreakerStackProps = {
  breakerStatus: DataPointWithValue | undefined;
  meterDataPoints: DataPointWithValue[] | undefined;
  translateXCoordinate: number;
  translateYCoordinate: number;
  dataPointsSectionTranslateXCoordinate: number;
  dataPointsSectionTranslateYCoordinate: number;
  meterLabel: string;
  feederALabel: string;
  feederBLabel: string;
};

export enum UnitDataPoints {
  KW = 'kW',
  KVAR = 'kVAR',
  SOC = 'SOC',
  RacksOnline = 'racks_online',
  InvStatus = 'InvStatus',
  RunMode = 'RunMode',
}
